import React, {useEffect, useState} from "react";
import './About.css'
import {ImageTitle} from '../../components/ImageTitle'
import Typography from "@mui/material/Typography";
import {Header} from "../../components/Header";
import {Banner} from "../../components/Banner";

interface AboutProps {
    imageUrl: string;
    title: string;
    path: string;
}

const About: React.FC<AboutProps> = ({ imageUrl, title, path }) => {

    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        setIsActive(true);
    }, []);

    return(
        <>
            <Header variant={2}/>
            <ImageTitle imageUrl={imageUrl} title={title} path={path}/>

            <div className={`transition-div ${isActive ? 'active' : ''}`}>
                <div className="left-about">
                    <Typography
                        sx={{
                            color: '#2d2d2d',
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 600,
                            fontSize: '43px',
                            marginBottom: '25px'
                        }}
                    >
                        Nuestra historia
                    </Typography>

                    <Typography
                        sx={{
                            color: '#4b4b4b',
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 500,
                            fontSize: '16px',
                            lineHeight: '2em'
                        }}
                    >
                        Nunc id cursus metus aliquam. Libero id faucibus nisl tincidunt eget. Aliquam id diam maecenas ultricies mi eget mauris. Volutpat ac tincierse id cursus metus aliquam. Libero id faucibus nisl tincidunt eget uam idsdf diam maecenas ultricies mi eget mauris. Volutpat ac tincidunt vitae efdg dunt vitae semper quis lectus.
                    </Typography>
                    <br/>
                    <Typography
                        sx={{
                            color: '#4b4b4b',
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 500,
                            fontSize: '16px',
                            lineHeight: '2em'
                        }}
                    >
                        A arcu cursus vitae congue mauris. Sagittis id consectetur purusllus tellus pellentesque eu tincidunt tortor aliquam nulla.
                    </Typography>

                </div>
                <div className="right-about">
                    <div className="square-text">
                        <Typography
                            sx={{
                                color: '#ffffff',
                                fontFamily: 'Inter, sans-serif',
                                fontWeight: 600,
                                fontSize: 'calc(2.5vw + 2.5rem)',
                            }}
                        >
                            40+
                        </Typography>
                        <Typography
                            sx={{
                                color: '#ffffff',
                                fontFamily: 'Inter, sans-serif',
                                fontWeight: 400,
                                fontSize: 'calc(1vw + 0.45rem)',
                            }}
                        >
                            Años de experiencia
                        </Typography>
                    </div>
                    <div className="square-text" style={{backgroundColor: '#26262C'}}>
                        <Typography
                            sx={{
                                color: '#ffffff',
                                fontFamily: 'Inter, sans-serif',
                                fontWeight: 600,
                                fontSize: 'calc(2.5vw + 2.5rem)',
                            }}
                        >
                            2K
                        </Typography>
                        <Typography
                            sx={{
                                color: '#ffffff',
                                fontFamily: 'Inter, sans-serif',
                                fontWeight: 400,
                                fontSize: 'calc(1vw + 0.45rem)',

                            }}
                        >
                            Clientes satisfechos
                        </Typography>
                    </div>
                </div>
            </div>

            <div className={`transition-element ${isActive ? 'active' : ''}`}>
                <div className="left-element">
                    <img src={"/Assets/vision.jpeg"} alt="" className="img-left"/>
                    <img src={"/Assets/mision.jpg"} alt="" className="img-right"/>
                    <img src={"/Assets/equipo.jpeg"} alt="" className="team"/>
                </div>
                <div className="right-element">
                    <div>
                        <Typography
                            sx={{
                                color: '#2d2d2d',
                                fontFamily: 'Inter, sans-serif',
                                fontWeight: 600,
                                fontSize: '40px',
                                    '@media (max-width: 1150px)': {
                                        fontSize: '30px',
                                    },
                                marginBottom: '20px',
                                marginTop: '30px'
                            }}
                        >
                            Objetivo
                        </Typography>

                        <Typography
                            sx={{
                                color: '#4b4b4b',
                                fontFamily: 'Inter, sans-serif',
                                fontWeight: 500,
                                fontSize: '16px',
                                    '@media (max-width: 1150px)': {
                                        fontSize: '15px',
                                    },
                                lineHeight: '2em',
                                marginBottom: '30px'

                            }}
                        >
                            Asesorar a nuestros clientes con base a las diferentes necesidades que requieran, logrando cumplir toda y cada una de las expectativas de protección tanto de su patrimonio como de vida brindando confianza, tranquilidad y satisfacción.
                        </Typography>
                        <Typography
                            sx={{
                                color: '#ff6c00',
                                fontFamily: 'Inter, sans-serif',
                                fontWeight: 600,
                                fontSize: '40px',
                                    '@media (max-width: 1150px)': {
                                        fontSize: '30px',
                                    },
                                marginBottom: '20px'
                            }}
                        >
                            Misión
                        </Typography>

                        <Typography
                            sx={{
                                color: '#4b4b4b',
                                fontFamily: 'Inter, sans-serif',
                                fontWeight: 500,
                                fontSize: '16px',
                                    '@media (max-width: 1150px)': {
                                        fontSize: '15px',
                                    },
                                lineHeight: '2em',
                                marginBottom: '30px'
                            }}
                        >
                            Somos una empresa que ofrece servicios de alta calidad y satisfacción a los clientes, buscando la protección de riesgos financieros ofreciendo siempre soluciones personalizadas para sus necesidades específicas, enfocándonos en la innovación y el uso de tecnologías para mejorar la experiencia del cliente.
                        </Typography>
                        <Typography
                            sx={{
                                color: '#2d2d2d',
                                fontFamily: 'Inter, sans-serif',
                                fontWeight: 600,
                                fontSize: '40px',
                                    '@media (max-width: 1150px)': {
                                        fontSize: '30px',
                                    },
                                marginBottom: '20px'
                            }}
                        >
                            Visión
                        </Typography>
                        <Typography
                            sx={{
                                color: '#4b4b4b',
                                fontFamily: 'Inter, sans-serif',
                                fontWeight: 500,
                                fontSize: '16px',
                                    '@media (max-width: 1150px)': {
                                        fontSize: '15px',
                                    },
                                lineHeight: '2em',
                                marginBottom: '30px'
                            }}
                        >
                            Buscamos mantener reputación sólida y confiable en el mercado, ser siempre líderes, enfocándonos en soluciones innovadoras y personalizadas, brindando un servicio al cliente excepcional, rápido, eficiente y personalizado, ayudando a construir confianza y la lealtad de todos nuestros asegurados, buscando una mejora continua de la calidad del servicio.
                        </Typography>
                    </div>
                </div>
            </div>

            <Banner title="¿Tienes preguntas?"/>

            <div style={{display: "flex", justifyContent: 'center', alignItems: 'center', width: '100%', height: 'auto', marginBottom: '50px'}}>
                <img src={"/Assets/aliados_color.png"} alt="Background" className="background-allies" />
            </div>

        </>
    )
}

export default About;